import { useSelector } from "../../../redux/store";
import { doc, updateDoc } from "firebase/firestore";
import { firestore } from "../../../utils/firebase/setupFirebase";
import { useEffect } from "react";

export const useFixingMyNameInTheGame = () => {
  const currentUser = useSelector((state) => state.auth.user);
  const game = useSelector((state) => state.game.game);
  const gameRefUrl = useSelector((state) => state.game.gameRefUrl);

  useEffect(() => {
    if (game && currentUser) {
      const me = game.membersMap[currentUser.uid];
      if (me?.displayName !== currentUser.displayName) {
        console.log("tt");
        const gameRef = doc(firestore, gameRefUrl!);
        updateDoc(gameRef, {
          [`membersMap.${currentUser.uid}.displayName`]:
            currentUser.displayName,
        });
      }
    }
    //eslint-disable-next-line  react-hooks/exhaustive-deps
  }, [game?.membersMap, currentUser]);
};
